import { render } from "./VerticalStepBar.vue?vue&type=template&id=5772c15b"
import script from "./VerticalStepBar.vue?vue&type=script&lang=ts"
export * from "./VerticalStepBar.vue?vue&type=script&lang=ts"
script.render = render

export default script